import { useTranslation } from "react-i18next";
import { Badge } from "../../shared/components/badge/Badge";
import { Link } from "react-router-dom";

const NavigationLink = ({ item, index, isSelected, onItemClick }) => {
  const { t } = useTranslation();

  return (
    <Link
      to={item.route}
      className={
        isSelected
          ? "text-foreground font-extrabold underline transition-colors hover:text-foreground"
          : "text-muted-foreground transition-colors hover:text-foreground"
      }
      onClick={() => onItemClick(index)}
    >
      <div className="flex flex-row gap-x-1 items-center">
        {t(item.label)}
        {item.status.toUpperCase() !== "STABLE" ? (
          <Badge variant="outline">
            {t(`defaults.itemStatus.${item.status.toLowerCase()}`)}
          </Badge>
        ) : (
          ""
        )}
      </div>
    </Link>
  );
};

export default NavigationLink;
